export class Diagnostico {
    Historia_Clinica_Id: number;
    Diagnostico: string;

    constructor(
        Diagnostico: string
    ) {
        this.Diagnostico = Diagnostico;
    }
}